import { ResolveFn } from '@angular/router';
import { AuthenticatedUserService, UserService } from '@markant-platform/shared/user/data-access';
import { firstValueFrom, map } from 'rxjs';
import { inject } from '@angular/core';
import { HistoryContext } from '@markant-platform/shared/audit/configuration';

export const OrganizationMemberHistoryResolver: ResolveFn<HistoryContext> = async route => {
  const authenticatedUserService = inject(AuthenticatedUserService);
  const userService = inject(UserService);

  const userId: string = route.paramMap.get('userId') as string;
  const organizationId: string =
    (route.paramMap.get('organizationId') as string) ??
    (await firstValueFrom(authenticatedUserService.getOrganizationId()));

  return await firstValueFrom(
    userService.getUserNames([userId]).pipe(
      map(({ userNames }) => {
        const { firstName, lastName } = userNames[userId];
        return {
          context: { userId, organizationId },
          name: `${firstName} ${lastName}`,
          entryTypes: ['User', 'AuthorizationAssignment'],
        };
      })
    )
  );
};
